import { createSelector } from "@reduxjs/toolkit";
import type { AppState } from "@redux/app-state";

export const selectTeacherUnpaidLessonsRetrieval = createSelector(
  [(state: AppState) => state.teacher.unpaidLessonsRetrieval],
  ({ data, fetching }) => ({ data, fetching }),
);
